import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { highlightedTypes } from "src/config/constants/genericConstants";

const useTable = (): {
  getJustifyContent: Function;
  getColumnLabel: Function;
  getColumnHighlight: Function;
} => {
  const { t } = useTranslation();

  const getJustifyContent = useCallback((align: string) => {
    if (align === "right") {
      return "end";
    } else if (align === "center") {
      return "center";
    }
    return "left";
  }, []);

  const getColumnLabel = useCallback((headerItem: any) => {
    if (headerItem.label) {
      return headerItem.label;
    }

    if (headerItem.title) {
      return t("tableHeaders." + headerItem.title);
    }

    return t("tableHeaders." + headerItem.id);
  }, []);

  const getColumnHighlight = useCallback(
    (headerItem: {
      highlightedType: string;
      isHighlighted: boolean;
    }): string | null => {
      if (!headerItem.isHighlighted) return null;

      return highlightedTypes[headerItem.highlightedType] ?? null;
    },
    []
  );

  return { getJustifyContent, getColumnLabel, getColumnHighlight };
};

export default useTable;
